import { ReactNode, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { paths } from '@/paths'
import { isRestrictedPath } from '@/lib/auth/roles'
import { logger } from '@/lib/default-logger'
import { usePathname } from '@/hooks/use-pathname'
import { useUser } from '@/hooks/use-user'

export interface AuthorizationGuardProps {
	children: ReactNode
}

// Checks if user has access to page based on their role
export function AuthorizationGuard({ children }: AuthorizationGuardProps) {
	const { user } = useUser()
	const navigate = useNavigate()
	const pathname = usePathname()

	useEffect(() => {
		if (!user) return // user should already be checked in AuthenticationGuard

		if (isRestrictedPath(user, pathname)) {
			logger.warn(`[AuthorizationGuard]: Unauthorized access to ${location.pathname}, redirecting...`)
			navigate(paths.notAuthorized, { replace: true })
		}
	}, [user, pathname, navigate])

	return <>{children}</>
}
